<template>
    <div class="sticky top-0 z-30 flex items-center flex-1 w-full p-4 bg-white dark:bg-slate-900 base-shadow">
        <Button
variant="secondary" size="sm" title="Toggle Sidebar" class="min-w-8 h-8 !p-0 justify-center mr-3 sm:hidden"
            :aria-expanded="!isCollapsed" aria-controls="sidebar-content"
            @click="$emit('toggleSidebar')">
            <PiCodeSimpleBold :size="20" class="text-neutral-400 size-4" />
        </Button>
        <h2 class="text-lg font-bold text-center text-neutral-600 dark:text-slate-100 font-manrope whitespace-nowrap">{{title}}</h2>

        <ul
            class="flex items-center w-full h-full pl-3 mx-3 overflow-x-auto overflow-y-visible border-l hide-scrollbar sm:pl-4 sm:ml-4">
            <li v-for="tab in tabs" :key="tab.title" class="pb-1.5 mx-1">
                <NuxtLink
v-slot="{ href, navigate }"
                    :to="tab.link"
                    custom>
                    <a
                        :href="href"
                        :class="[ 'flex-shrink-0 p-2 py-1.5 whitespace-nowrap transition text-sm font-medium text-neutral-400 dark:text-slate-300 hover:text-neutral-600 dark:hover:text-white font-manrope hover:bg-slate-50 dark:hover:bg-slate-800', isTabActive(tab.link) ? 'border-b-2 border-b-[#B2B8BD] !text-neutral-600 dark:!text-white opacity-100' : '', ]"
                        @click="navigate"
                    >
                    {{ tab.title }}
                    </a>
                </NuxtLink>
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
import Button from "~/components/common/Button.vue";
import { PiCodeSimpleBold } from "vue3-icons/pi";

defineProps<{
    isCollapsed: boolean,
    tabs: { title: string, link: string }[],
    title: string
}>()

defineEmits(['toggleSidebar'])

const route = useRoute();

const isTabActive = (link: string) => {
    return route.path === link || route.path.startsWith(`${link}/`);
};
</script>